// extracted by mini-css-extract-plugin
export default {"root":"HIUKwo","disabled":"eKcHXl","readonly":"ghl_vK","separator":"_9TLCi","actionWrapper":"_uY73j","actionText":"hWag3q","icon":"fhgQYN"};